<script>
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: { PhxIcon },
};
</script>

<template>
  <div class="input-adornment">
    <phx-icon icon="checkmark" class="icon--2xs input--filled__icon" />
  </div>
</template>
